import React, { useRef, useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { ReactComponent as ArrowForward } from "./arrowfwrd.svg";
import { ReactComponent as ArrowBackward } from "./arrowbwrd.svg";
import { ReactComponent as ArrowDown } from "./arrowdown.svg";
import { ReactComponent as ArrowImproved } from "./improved.svg";
import { ReactComponent as Star } from "./star.svg";
import { useNavigate, Link } from "react-router-dom";

export default function Shop() {
  const [currentSkinIndex, setCurrentSkinIndex] = useState(0);
  const [currentWpnIndex, setCurrentWpnIndex] = useState(0);
  const [rightWpnArrowAnimating, setRightWpnArrowAnimating] = useState(false);
  const [leftWpnArrowAnimating, setLeftWpnArrowAnimating] = useState(false);
  const [rightSkinsArrowAnimating, setRightSkinsArrowAnimating] =
    useState(false);
  const [leftSkinsArrowAnimating, setLeftSkinsArrowAnimating] = useState(false);
  const benefitsRef = useRef(null);
  const [showBenefits, setShowBenefits] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const preloadImages = () => {
      for (let i = 0; i < 14; i++) {
        const img = new Image();
        img.src = `/weapons/weaponph${i}.gif`;
      }
    };
    preloadImages();

    if (document.body.scrollHeight <= window.innerHeight && !showBenefits) {
      setShowBenefits(true);
    }

    const handleScroll = () => {
      if (document.documentElement.scrollTop > 0 && !showBenefits) {
        setShowBenefits(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const nextWpnSlide = () => {
    let nextIndex = currentWpnIndex + 1;
    setRightWpnArrowAnimating(true);
    setTimeout(() => setRightWpnArrowAnimating(false), 300);
    if (nextIndex > 13) {
      nextIndex = 0;
    }

    setCurrentWpnIndex(nextIndex);
  };

  const prevWpnSlide = () => {
    let nextIndex = currentWpnIndex - 1;
    setLeftWpnArrowAnimating(true);
    setTimeout(() => setLeftWpnArrowAnimating(false), 300);
    if (nextIndex < 0) {
      nextIndex = 13;
    }

    setCurrentWpnIndex(nextIndex);
  };

  const nextSkinSlide = () => {
    let nextIndex = currentSkinIndex + 1;
    setRightSkinsArrowAnimating(true);
    setTimeout(() => setRightSkinsArrowAnimating(false), 300);
    if (nextIndex > 2) {
      nextIndex = 0;
    }

    setCurrentSkinIndex(nextIndex);
  };

  const prevSkinSlide = () => {
    let nextIndex = currentSkinIndex - 1;
    setLeftSkinsArrowAnimating(true);
    setTimeout(() => setLeftSkinsArrowAnimating(false), 300);

    if (nextIndex < 0) {
      nextIndex = 2;
    }

    setCurrentSkinIndex(nextIndex);
  };

  const goToMain = () => {
    navigate("/");
  };

  const goToPortal = () => {
    navigate("/portal");
  };

  const seeBenefits = () => {
    if (!showBenefits) {
      setShowBenefits(true);
      setTimeout(() => {
        benefitsRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 0);
    }
  };

  return (
    <>
      <div className="root">
        <div className="logoContainer" onClick={() => goToMain()}>
          <div className="logoSmaller">
            <b>kfOne</b>
          </div>
          <div className="underLogoSmaller">
            <b>Killing Floor 1 Server</b>
          </div>
        </div>

        <div className="shopMenu">
          <div className="titleText">
            <b>Best way to support us</b>
          </div>
          <div className="helpDescription">
            <b>This helps to keep the server up and running</b>
          </div>
          <div className="itemTitleText">
            <b>VIP</b>
          </div>
          <div className="itemPriceText">
            <b>
              <s>6.45 €</s>
            </b>
          </div>
          <div className="itemPriceTextNew">
            <b>0.00 €</b>
          </div>
          <div className="buyButtonContainer">
            <Link style={{ color: "inherit" }} to="/terms-and-conditions">
              Terms and Conditions
            </Link>
          </div>
          <div className="buyButtonContainer">
            <Button
              variant="dark"
              className="buyButtonSmaller"
              onClick={() => goToPortal()}
            >
              Claim now
            </Button>
          </div>
          {!showBenefits ? (
            <div onClick={() => seeBenefits()}>
              <div className="seeBenefitsContainer">
                <p>See benefits below</p>
                <ArrowDown className="arrowDown" />
              </div>
            </div>
          ) : (
            <div />
          )}
          {showBenefits ? (
            <div>
              <div className="dotsContainer">
                {/* <b className="dotBoldedTextSmaller">•</b> */}
                <b className="dotBoldedTextSmaller">__</b>
                {/* <b className="dotBoldedTextSmaller">•</b> */}
              </div>
              <div className="appearingBenefitsWrapper">
                <div className="appearingBenefits">
                  <div className="benefitsBox">
                    <div ref={benefitsRef} className="benefitsBoldedText">
                      <b>Benefits</b>
                    </div>
                    <div className="dotBoldedTextSmaller">___</div>
                    <p className="benefitsText">
                      Doubled <b>experience</b> on all perks
                      <ArrowImproved className="arrowImproved" />
                    </p>
                    <p className="benefitsText">
                      Improved <b>welder</b> for all perks
                      <ArrowImproved className="arrowImproved" />
                    </p>
                    <p className="benefitsText">
                      Increased <b>movement speed</b>
                      <ArrowImproved className="arrowImproved" />
                    </p>
                    <p className="benefitsText">
                      Additional <b>weapons</b>
                      <Star className="star" />
                    </p>
                    <p className="benefitsText">
                      Additional <b>character skins</b>
                      <Star className="star" />
                    </p>
                    <p className="benefitsText">
                      VIP badge
                      <Star className="star" />
                    </p>
                  </div>

                  {/* <div className="benefitsBoldedText">
                            <b>VIP skins</b>
                        </div>
                        <div className="charImageBox">
                            <ArrowBackward onClick={prevSkinSlide} className={leftSkinsArrowAnimating ? "arrowLeftClicked" : "arrowLeft"}/>
                            <img className="charInnerImageBox" src={"/skins/charph" + currentSkinIndex + ".png"} />
                            <ArrowForward onClick={nextSkinSlide} className={rightSkinsArrowAnimating ? "arrowRightClicked" : "arrowRight"}/>
                        </div> */}

                  <div className="benefitsBox">
                    <div className="benefitsBoldedText">
                      <b>Weapons</b>
                    </div>
                    <div className="dotBoldedTextSmaller">___</div>
                    <div className="gunsImageBox">
                      <ArrowBackward
                        onClick={prevWpnSlide}
                        className={
                          leftWpnArrowAnimating
                            ? "arrowLeftClicked"
                            : "arrowLeft"
                        }
                      />
                      <img
                        className="gunsInnerImageBox"
                        src={"/weapons/weaponph" + currentWpnIndex + ".gif"}
                      />
                      <ArrowForward
                        onClick={nextWpnSlide}
                        className={
                          rightWpnArrowAnimating
                            ? "arrowRightClicked"
                            : "arrowRight"
                        }
                      />
                    </div>
                  </div>
                </div>
                <footer className="footerShop">
                  <p>© {new Date().getFullYear()}</p>
                </footer>
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    </>
  );
}
